const { get_header_height, disable_page_scroll, enable_page_scroll } = require('../helpers/_utils');

module.exports = function init_timeline() {
  if(document.querySelector('.tech-timeline-row')) {
    const header_ht = get_header_height();
    const content_section = document.querySelector('.tech-timeline-row');
    const content_wrapper = content_section.querySelector('.fl-row-content');
    const next_section = content_section.nextElementSibling;
    let content_section_top;
    let content_section_height;
    let content_scroll_height;
    let next_section_top;

    let inner_scroll_position = 0;

function update_measurements() {
  content_section_top = content_section.offsetTop;
  content_section_height = content_section.offsetHeight;
  content_scroll_height = content_wrapper.scrollHeight;
  next_section_top = next_section ? next_section.offsetTop : document.body.scrollHeight;
  
  total_scroll_height = content_scroll_height - (window.innerHeight - header_ht);
  is_inner_scroll_complete = false;
  
  console.log('next section top:', next_section_top);
  console.log('content section height:', content_section_height);
  console.log('content scroll height:', content_scroll_height);
  console.log('total scroll height:', total_scroll_height);
}

let is_inner_scroll_complete = false;

function handle_inner_scroll() {
  inner_scroll_position = content_wrapper.scrollTop;
  const scroll_progress = inner_scroll_position / total_scroll_height;
  console.log('inner scroll progress:', scroll_progress);

  if (scroll_progress >= 1 && !is_inner_scroll_complete) {
    is_inner_scroll_complete = true;
    content_section.classList.remove('fixed');
    content_section.style.top = `${next_section_top - viewport_height - content_section_top}px`;
    enable_page_scroll();
    console.log('Inner scroll complete, unfixing section');
  }
}

function handle_scroll() {
  const scroll_y = window.scrollY;
  const viewport_height = window.innerHeight;

  console.log('scroll-y:', scroll_y);

  if (scroll_y >= content_section_top && scroll_y < next_section_top - viewport_height && !is_inner_scroll_complete) {
    console.log('fixing...');
    content_section.classList.add('fixed');
    content_section.style.top = `${header_ht}px`;
    
    content_wrapper.style.height = `${viewport_height - header_ht}px`;
    content_wrapper.style.overflowY = 'auto';
    
    const scroll_into_section = scroll_y - content_section_top;
    inner_scroll_position = Math.min(scroll_into_section, total_scroll_height);
    content_wrapper.scrollTop = inner_scroll_position;

    disable_page_scroll();

    const scroll_progress = inner_scroll_position / total_scroll_height;
    console.log('scroll progress:', scroll_progress);

  } else if (scroll_y < content_section_top) {
    console.log('above section - remove fix');
    content_section.classList.remove('fixed');
    content_section.style.top = '';
    content_wrapper.style.height = '';
    content_wrapper.style.overflowY = 'hidden';
    content_wrapper.scrollTop = 0;
    inner_scroll_position = 0;
    is_inner_scroll_complete = false;
    enable_page_scroll();
  }
}



    update_measurements();
    window.addEventListener('scroll', handle_scroll);
    window.addEventListener('resize', () => {
      update_measurements();
      handle_scroll();
    });
    content_wrapper.addEventListener('scroll', handle_inner_scroll);

    window.addEventListener('scroll', () => {
      if (is_inner_scroll_complete) {
        const scroll_y = window.scrollY;
        if (scroll_y < content_section_top) {
          is_inner_scroll_complete = false;
        }
      }
    });
  }
}